// Columns for account master data table
export const AccountMasterDataTableColumns = [
  {
    label: "Company Logo",
    excelName: "Company Logo",
    // columnWidth: "200px",
    isSort: false,
    id: "logo",
  },
  {
    label: "Company Name",
    excelName: "Company Name",
    // columnWidth: "200px",
    isSort: false,
    id: "name",
  },
  {
    label: "Email",
    excelName: "Email",
    // columnWidth: "200px",
    isSort: false,
    id: "email",
  },
  {
    label: "Coordinator(SPOC)",
    excelName: "Coordinator(SPOC)",
    // columnWidth: "200px",
    isSort: false,
    id: "spocPerson",
  },
  {
    label: "Contact Number",
    excelName: "Contact Number",
    // columnWidth: "200px",    
    isSort: false,
    id: "phoneNumber",
  },
  {
    label: "Action",
    isSort: false,
    id: "ActionToEditAndDelete",
    isIcon: true,
    cellAlign: "center",
    columnWidth: "200px",
    headerAlign: "center",
  },
];
